fx.ns("desktop.book.edition", class PhotoList extends fx.Component {
    
	constructor(data)
	{
		super(data);

		this.showEffect = "hslideout";
        this.hideEffect = "hslidein";;
        
		this.destroyOnSwitch = true;
	}
    
	create()
	{
		super.create();

		this.stepComponent = new desktop.book.edition.PhotoListStep(this.data);
		
		let gridWidth = fx.graphics.screenSize().width > 1024 ? 1024 : "100%";

		this.grid = new fx.components.VerticalGridDynamic( {	data : this.data.photos.available, 
																renderers : {Photo : shared.renderers.PhotoSelectRenderer}, 
																scrollOnNew : false, 
																hasOnlyUnique : true,
																newChildEffect : "scale",
																maxRowHeight : 200,
																containerWidth : gridWidth,
																containerLeft : "center",
																headerComponent : { component : this.stepComponent, 
																					position : "sticky",
																					viewport : {top : 0, left : "center", width : gridWidth, height : 200} }
		 } );

		 this.grid.filter = new filters.SortPhotosChronological();

		
		this.addChild(this.grid, {height:"fill", width:"100%", left : "center", top : 0});

		if (fx.get("mode") !=  "creating-ia")
		{
			this.backButton = new fx.components.IconButton( {icon: fx.get("assets").ExitIcon, className : "exit", toolTip : fx.text("Aller à votre album")} );
			this.addChild(this.backButton, {right:25, top:10, width:50, height:50});		
		}
		
		this.returnContainer = new fx.components.Box("return");
		this.returnButton = new fx.components.IconButton( {icon: fx.get("assets").arrowBack} );
		this.backText = new fx.components.Text({text : fx.text("Ajouter des photos"), className : "button-label link right-label"});
		this.returnContainer.addChild(this.returnButton, {width:40, height:40, left : 0, top : 0})
		this.returnContainer.addChild(this.backText, {width: 220, height : 20, top : 10, left : 40})
		this.addChild( this.returnContainer, {top : 15, left : 15, width:260, height:40});		

		
		if (this.data.creator.selectedThemetag)
		{
			this.nextContainer = new fx.components.Box("back-container");
			this.nextButton = new fx.components.IconButton( {icon: fx.assets.arrowNext} );
			let text = new fx.components.Text({text : fx.text("Type d'album"), className : "button-label link"});
			this.nextContainer.addChild(text, {width: 150, height : 20, top : 10, left : -35})
			this.nextContainer.addChild(this.nextButton, {width:40, height:40, left : 110, top : 0})
			this.addChild( this.nextContainer, {top : 15, right : 25, width:150, height:40});
		}
	
	}

	onReady()
	{
		if (this.backButton)
			this.on("click", this._onExit, this.backButton);

		this.on("scroll", this._onScroll, this.grid);

		this.on("click", this._onBack, this.returnContainer);

		if (this.nextContainer)
			this.on("click", this._onNext, this.nextContainer);

		this.on("create", this._onCreate, this.stepComponent);

		this.data.creator.selectPictures();
	}

	onDisplayUpdated()
	{
		super.onDisplayUpdated();

		this.backText.toggle( fx.graphics.screenSize().width > 1550 );
	}

	_onExit(e)
	{        
		this.hideEffect = "hslideout";
		this.data.event("show-editor");
	}

	_onBack(e)
	{
		this.hideEffect = "hslideout";
		this.data.event("previous-step");
	}

	_onNext()
	{
		this.data.event("next-step");
	}

	_onCreate()
	{
		/*if (this.data.creator.albums().length == 1)
			this.data.event("step-CreatingAlbum");
		else*/
			this.data.event("next-step");
	}

	_onScroll()
	{
		if (this.grid.node.scrollTop >= this.grid.headerComponent.component.realHeight)
			this.grid.headerComponent.component.small();
		else
			this.grid.headerComponent.component.big();
	}
	

});